import { CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID } from '@src/config/env'
import { initGtag } from '@src/telemetry/integrations/GoogleAdsTag'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TelemetryIntegration } from '../telemetry-events.types'

import { initializeScript } from './provider-utils/initialize-script'

export const GoogleAnalytics4: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.GOOGLE_TAG_MANAGER,
  },

  initialize: async () => {
    initGtag()
    await initializeScript({
      key: 'google-ads-ga4',
      domain: TELEMETRY_DOMAINS.GOOGLE_TAG_MANAGER,
      path: `/gtag/js?id=${CONFIG_KEY_GOOGLE_GTM_WEB_CONTAINER_ID}`,
      injectAt: 'beforeFirstScript',
    })
  },

  events: {},
}
